module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "printer-container"
  }, [_c('div', {
    staticClass: "condition-container"
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.queryParams
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "clearable": "",
      "placeholder": "请输入设备编号"
    },
    model: {
      value: (_vm.queryParams.imei),
      callback: function($$v) {
        _vm.$set(_vm.queryParams, "imei", $$v)
      },
      expression: "queryParams.imei"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    attrs: {
      "clearable": "",
      "placeholder": "请输入设备名称"
    },
    model: {
      value: (_vm.queryParams.printerName),
      callback: function($$v) {
        _vm.$set(_vm.queryParams, "printerName", $$v)
      },
      expression: "queryParams.printerName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择设备是否在线"
    },
    model: {
      value: (_vm.queryParams.online),
      callback: function($$v) {
        _vm.$set(_vm.queryParams, "online", $$v)
      },
      expression: "queryParams.online"
    }
  }, _vm._l((_vm.onlineOptions), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择设备状态"
    },
    model: {
      value: (_vm.queryParams.status),
      callback: function($$v) {
        _vm.$set(_vm.queryParams, "status", $$v)
      },
      expression: "queryParams.status"
    }
  }, _vm._l((_vm.statusOptions), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.query(1)
      }
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.showForm()
      }
    }
  }, [_vm._v("新增")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "data-container"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "data": _vm.list,
      "stripe": "",
      "border": ""
    }
  }, [_c('div', {
    attrs: {
      "slot": "empty"
    },
    slot: "empty"
  }, [_c('el-empty', {
    attrs: {
      "description": "暂无数据"
    }
  })], 1), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "设备类型",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.type == 1) ? _c('el-tag', {
          attrs: {
            "type": "primary"
          }
        }, [_vm._v("云打印机")]) : (scope.row.type == 2) ? _c('el-tag', {
          attrs: {
            "type": "warning"
          }
        }, [_vm._v("蓝牙云盒")]) : _c('el-tag', {
          attrs: {
            "type": "danger"
          }
        }, [_vm._v("其他")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "imei",
      "label": "编号(SN)"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "账号秘钥"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', [_vm._v(_vm._s(scope.row.printerUsername))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(scope.row.printerPassword))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "printerName",
      "label": "名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "是否在线",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.dataflow == 1) ? _c('el-tag', {
          attrs: {
            "type": "success"
          }
        }, [_vm._v("云对云")]) : (scope.row.online == 1) ? _c('el-tag', {
          attrs: {
            "type": "success"
          }
        }, [_vm._v("在线")]) : _c('el-tag', {
          attrs: {
            "type": "danger"
          }
        }, [_vm._v("离线")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "状态",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.dataflow == 1) ? _c('el-tag', {
          attrs: {
            "type": "success"
          }
        }, [_vm._v("云对云")]) : (scope.row.online == 1 && scope.row.status == 1) ? _c('el-tag', {
          attrs: {
            "type": "success"
          }
        }, [_vm._v("正常")]) : _c('el-tag', {
          attrs: {
            "type": "danger"
          }
        }, [_vm._v("异常")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "toPrintTaskCount",
      "label": "待打印",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "374"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "mini",
            "type": "info"
          },
          on: {
            "click": _vm.handleRefresh
          }
        }, [_c('i', {
          staticClass: "el-icon-refresh"
        })]), _vm._v(" "), _c('el-dropdown', {
          staticStyle: {
            "margin-left": "10px",
            "margin-right": "10px"
          },
          attrs: {
            "size": "mini",
            "split-button": "",
            "type": "primary",
            "trigger": "click"
          },
          on: {
            "visible-change": function($event) {
              return _vm.setCurrPrinter(scope.row)
            },
            "command": _vm.handleCommand
          }
        }, [_vm._v("\n                        测试\n                        "), _c('el-dropdown-menu', {
          attrs: {
            "slot": "dropdown"
          },
          slot: "dropdown"
        }, [_c('el-dropdown-item', {
          attrs: {
            "command": "text"
          }
        }, [_vm._v("普通文字")]), _vm._v(" "), _c('el-dropdown-item', {
          attrs: {
            "command": "textCut"
          }
        }, [_vm._v("普通文字(切纸)")]), _vm._v(" "), _c('el-dropdown-item', {
          attrs: {
            "command": "newOrder",
            "divided": ""
          }
        }, [_vm._v("新订单")]), _vm._v(" "), _c('el-dropdown-item', {
          attrs: {
            "command": "realOrder",
            "divided": ""
          }
        }, [_vm._v("完整订单")]), _vm._v(" "), _c('el-dropdown-item', {
          attrs: {
            "command": "realOrderCut",
            "divided": ""
          }
        }, [_vm._v("完整订单(切纸)")]), _vm._v(" "), _c('el-dropdown-item', {
          attrs: {
            "command": "hurryOrder",
            "divided": ""
          }
        }, [_vm._v("催单")]), _vm._v(" "), _c('el-dropdown-item', {
          attrs: {
            "command": "cancelOrderApply",
            "divided": ""
          }
        }, [_vm._v("申请取消订单")]), _vm._v(" "), _c('el-dropdown-item', {
          attrs: {
            "command": "cancelOrder",
            "divided": ""
          }
        }, [_vm._v("订单已取消")]), _vm._v(" "), _c('el-dropdown-item', {
          attrs: {
            "command": "refundOrder",
            "divided": ""
          }
        }, [_vm._v("订单已退款")]), _vm._v(" "), _c('el-dropdown-item', {
          attrs: {
            "command": "advanceOrder",
            "divided": ""
          }
        }, [_vm._v("待处理预约单")]), _vm._v(" "), _c('el-dropdown-item', {
          attrs: {
            "command": "newNotice",
            "divided": ""
          }
        }, [_vm._v("新的提醒消息")]), _vm._v(" "), _c('el-dropdown-item', {
          attrs: {
            "command": "517",
            "divided": ""
          }
        }, [_vm._v("517LOGO")]), _vm._v(" "), _c('el-dropdown-item', {
          attrs: {
            "command": "HP",
            "divided": ""
          }
        }, [_vm._v("好评LOGO")]), _vm._v(" "), _c('el-dropdown-item', {
          attrs: {
            "command": "JD",
            "divided": ""
          }
        }, [_vm._v("京东LOGO")])], 1)], 1), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "success"
          },
          on: {
            "click": function($event) {
              return _vm.showForm(scope.row)
            }
          }
        }, [_vm._v("编辑\n                    ")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "warning",
            "disabled": scope.row.toPrintTaskCount == 0
          },
          on: {
            "click": function($event) {
              return _vm.handleClear(scope.row)
            }
          }
        }, [_vm._v("清空\n                    ")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.handleDelete(scope.row.id)
            }
          }
        }, [_vm._v("删除\n                    ")])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "paging-container paging"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.queryParams.pageNum,
      "page-sizes": _vm.$pageSizes,
      "page-size": _vm.queryParams.pageSize,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.title,
      "visible": _vm.dialogFormVisible,
      "close-on-click-modal": false,
      "before-close": _vm.handleClose,
      "width": "480px"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "infoForm",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules,
      "label-width": "60px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "编号",
      "prop": "imei"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": _vm.form.id ? true : false
    },
    model: {
      value: (_vm.form.imei),
      callback: function($$v) {
        _vm.$set(_vm.form, "imei", $$v)
      },
      expression: "form.imei"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "名称",
      "prop": "printerName"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": "256"
    },
    model: {
      value: (_vm.form.printerName),
      callback: function($$v) {
        _vm.$set(_vm.form, "printerName", $$v)
      },
      expression: "form.printerName"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.handleClose
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-51d607ac"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/main/printer.vue
// module id = 337
// module chunks = 1